$(document).ready(function() {

    if ($('.banner-slider:not(.v2)').length) {
      
        if(enabled_transparent_banner_slider){
          let headerHWrapper = $('.header .header-wrapper').height();
          let headerHWrapperMobile = $('.header .header-wrapper-mobile').height();
          
          if ( headerHWrapper != 0 ){
              $('.banner-slider').css('margin-top', `-${headerHWrapper }px`);
          }else{
              $('.banner-slider').css('margin-top', `-${headerHWrapperMobile }px`);
          }
          
        }
        $('.banner-slider:not(.v2) .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: true,
                smartSpeed: 800,
                loop: false,
                autoplay: false,
                autoplayTimeout: 5000,
                margin: 0,
                responsive: {
                    0: {
                        margin: 0
                    },
                    1280: {
                        margin: 0
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }

                // Play video in active slide if available
                let $currentSlide = $carousel.find('.owl-item').eq(currentIndex);
                let $video = $currentSlide.find('video').get(0);
                if ($video) {
                    $video.play();
                }
              
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');

        });
    }

    if ($('.awards-slider-section').length) {
        new Swiper('.awards-slider', {
            autoplay: {
                enabled: true,
                delay: 0,
                pauseOnMouseEnter: false,
                disableOnInteraction: true,
            },
            centeredSlides: true,
            loop: true,
            navigation: false,
            noSwipingClass: 'swiper-slide',
            slidesPerView: 'auto',
            spaceBetween: 0,
            speed: animation_scroll_speed,
          });
    }

  
  
    if ($('.category-list-product-section').length) {
        $('.category-list-product-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                smartSpeed: 800,
                loop: false,
                autoplay: false,
                stagePadding: 20,
                margin: 15
              
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');
        });
      
    }
  
    if ($('.vertical-slider').length) {
        $('.vertical-slider-owl .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                smartSpeed: 800,
                loop: false,
                autoplay: false,
                stagePadding: 30,
                margin: 15
              
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.brand-reviews').length) {
        $('.brand-reviews').each(function() {
            let $carousel = $(this).find('.owl-carousel');
            let $floatNav = $carousel.next('.float-nav');
        
            $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: false,
                loop: true,
                autoHeight: true,
                smartSpeed: 800,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive: {
                    0: {
                        items: 1,
                        margin: 30
                    },
                    1280: {
                        items: 3,
                        margin: 50
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                // let currentIndex = event.item.index;
                // let totalItems = event.item.count;
                // let pageSize = event.page.size;
      
                // if (currentIndex === 0) {
                //     $floatNav.find('.owl-prev').prop('disabled', true);
                // } else {
                //     $floatNav.find('.owl-prev').prop('disabled', false);
                // }
    
                // if (currentIndex >= totalItems - pageSize) {
                //     $floatNav.find('.owl-next').prop('disabled', true);
                // } else {
                //     $floatNav.find('.owl-next').prop('disabled', false);
                // }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');

        });
    }

    if ($('.agent-reviews-section').length) {
        $('.agent-reviews-section').each(function() {
            let $carousel = $(this).find('.owl-carousel');
            let $floatNav = $carousel.next('.float-nav');
            let $imageContainer = $(this).find('.agent-image-container');
        
            $carousel.owlCarousel({
                items: 1,
                nav: true,
                mouseDrag: false,
                dots: false,
                loop: true,
                autoHeight: true,
                slideSpeed: 500,
                animateOut: 'fadeOut',
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                animateIn: 'fadeIn'
              
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                let $currentItem = $(event.target)
                  .find('.owl-item')
                  .eq(event.item.index)
                  .find('.item');
          
                let currentDataItem = $currentItem.data('item');
          
                // Remove .active from all images
                $imageContainer.find('img').removeClass('active');
          
                // Add .active to the matching image
                $imageContainer.find('img[data-item="' + currentDataItem + '"]').addClass('active');
                
                $floatNav.find('.owl-next').prop('disabled', false);
                $floatNav.find('.owl-prev').prop('disabled', false);
                
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');

        });
    }
  
    if ($('.social-gallery-section').length) {
        $('.gallery-slider').each(function() {
            let $carousel = $(this).find('.owl-carousel');
            let $floatNav = $carousel.next('.float-nav');
        
            $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                loop: false,
                margin: 15,
                autoHeight: true,
                slideSpeed: 300
              
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
              
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                } 
                
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');
          
        });
    }

    if ($('.blog-posts-section').length) {
        $('.blog-posts-section').each(function() {
            let $carousel = $(this).find('.owl-carousel');
            let $floatNav = $carousel.next('.float-nav');
        
            $carousel.owlCarousel({
                items: 2,
                nav: true,
                dots: false,
                loop: false,
                margin: 15,
                autoHeight: true,
                slideSpeed: 300
              
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
              
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                } 
                
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');
          
        });
    }
  
    if ($('.influencer-video-section').length) {
        $('.influencer-video-section').each(function() {
            let $carousel = $(this).find('.owl-carousel');
            let $floatNav = $carousel.next('.float-nav');
        
            $carousel.owlCarousel({
                items: 4,
                nav: false,
                dots: false,
                loop: true,
                autoHeight: true,
                smartSpeed: 800,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1,
                        margin: 15,
                        stagePadding: 20
                    },
                    1280: {
                        items: 4,
                        margin: 20,
                        stagePadding: 0
                    }
                }
            }).on('changed.owl.carousel', function (event) {
                // let currentIndex = event.item.index;
                // let totalItems = event.item.count;
                // let pageSize = event.page.size;
      
                // if (currentIndex === 0) {
                //     $floatNav.find('.owl-prev').prop('disabled', true);
                // } else {
                //     $floatNav.find('.owl-prev').prop('disabled', false);
                // }
    
                // if (currentIndex >= totalItems - pageSize) {
                //     $floatNav.find('.owl-next').prop('disabled', true);
                // } else {
                //     $floatNav.find('.owl-next').prop('disabled', false);
                // }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');

          
        });

      
        $('.influencer-video-section .video-item').each(function() {
            var $video = $(this).find('video')[0];
            var $playButton = $(this).find('.play-button-icon');
            var $modal = $('.influencer-video-section').find('.influencer-mdl');
            var $modalVideo = $modal.find('.featured-video')[0];
        
            // Play button click event
            $playButton.click(function(e) {
                e.stopPropagation(); // prevent click from bubbling
        
                // Set the modal video source to the clicked video's source
                $modalVideo.src = $video.currentSrc || $video.src;
        
                // Add .active class to show modal
                $modal.show();
        
                // Play the video inside the modal
                $modalVideo.play();
            });
        
            // Close modal event
            $('.mdl-close, .mdl .overlay').click(function() {
                $modalVideo.pause();
                $modalVideo.currentTime = 0;
            });
        });
      
    }
  
      
    vertical_slider();
    jmgo_mask();
});

$(window).on('scroll', function() {
    vertical_slider();
    jmgo_mask();
});

function vertical_slider() {
    $('.vertical-slider').each(function () {
      
        var hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').height();
        $('.vertical-slider .wrapper .container').css('top', `${hAnnouncementbarDynamic }px`);
      
        let el = $(this);

        let $images = $(this).find('.wrapper .image-container');
        let $toggles = $(this).find('.wrapper .toggles');
        let $data = $(this).find('.wrapper .data-container');

        if ($(this).find('.wrapper').data('size') == 1) {
            $(this).find('.wrapper').css('height', '100vh');
        }
              
        if ($(this).find('.wrapper').data('size') == 2) {
            $(this).find('.wrapper').css('height', '200vh');
        
            let scrolled = visiblePercent(el) * 2.2;
        
            if (scrolled >= 120) {
                $images.find('img:nth-child(1)').css({ 'bottom': '120%', 'scale': '1', 'right': '15%' });
                $images.find('img:nth-child(2)').css({ 'bottom': '0', 'scale': '1', 'right': '0%' });
        
                $data.find('.data:nth-child(1)').css({ 'top': '-100%', 'opacity': '0' });
                $data.find('.data:nth-child(2)').css({ 'top': '35%', 'opacity': '1' });
            } else {
                $images.find('img:nth-child(1)').css({ 'bottom': '0', 'scale': '1' });
                $images.find('img:nth-child(2)').css({ 'bottom': '0', 'scale': '0.93' });
        
                $data.find('.data:nth-child(1)').css({ 'top': '35%', 'opacity': '1', 'right': '15%' });
                $data.find('.data:nth-child(2)').css({ 'top': '100%', 'opacity': '0', 'right': '0%' });
            }
        }
        
        if ($(this).find('.wrapper').data('size') == 3) {
            $(this).find('.wrapper').css('height', '200vh');
        
            let scrolled = visiblePercent(el) * 2.2;
        
            if (scrolled >= 120 && scrolled < 160) {
                $images.find('img:nth-child(1)').css({ 'bottom': '120%', 'scale': '1', 'right': '20%' });
                $images.find('img:nth-child(2)').css({ 'bottom': '0', 'scale': '1', 'right': '10%', });
                $images.find('img:nth-child(3)').css({ 'bottom': '0', 'scale': '0.93', 'right': '0%', });
        
                $data.find('.data:nth-child(1)').css({ 'top': '-100%', 'opacity': '0' });
                $data.find('.data:nth-child(2)').css({ 'top': '35%', 'opacity': '1' });
                $data.find('.data:nth-child(3)').css({ 'top': '100%', 'opacity': '0' });
            }
            else if (scrolled >= 160) {
                $images.find('img:nth-child(1)').css({ 'bottom': '120%', 'scale': '1', 'right': '20%'  });
                $images.find('img:nth-child(2)').css({ 'bottom': '120%', 'scale': '1', 'right': '15%', });
                $images.find('img:nth-child(3)').css({ 'bottom': '0', 'scale': '1', 'right': '5%' });
        
                $data.find('.data:nth-child(1)').css({ 'top': '-100%', 'opacity': '0' });
                $data.find('.data:nth-child(2)').css({ 'top': '-100%', 'opacity': '0' });
                $data.find('.data:nth-child(3)').css({ 'top': '35%', 'opacity': '1' });
            } else {
                $images.find('img:nth-child(1)').css({ 'bottom': '0', 'scale': '1', 'right': '20%' });
                $images.find('img:nth-child(2)').css({ 'bottom': '0', 'scale': '1', 'right': '10%', });
                $images.find('img:nth-child(3)').css({ 'bottom': '0', 'scale': '0.93', 'right': '0%', });
        
                $data.find('.data:nth-child(1)').css({ 'top': '35%', 'opacity': '1' });
                $data.find('.data:nth-child(2)').css({ 'top': '100%', 'opacity': '0' });
                $data.find('.data:nth-child(3)').css({ 'top': '100%', 'opacity': '0' });
            }
        }

      
        if ($(this).find('.wrapper').data('size') == 4) {
            $(this).find('.wrapper').css('height', '250vh');

            let scrolled = visiblePercent(el) * 2.2;
          
            if (scrolled >= 110 && scrolled < 140) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '120%',
                    'right': '29%',
                    'scale': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '0',
                    'right': '28%',
                    'scale': '1'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '0',
                    'right': '13%',
                    'scale': '0.93'
                });
                $images.find('img:nth-child(4)').css({
                    'bottom': '0',
                    'right': '1%',
                    'scale': '0.83'
                });
              

                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '35%',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(4)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
            else if (scrolled >= 140  && scrolled < 170) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '120%',
                    'right': '29%',
                    'scale': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '120%',
                    'right': '28%',
                    'scale': '1'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '0',
                    'right': '28%',
                    'scale': '1'
                });
                $images.find('img:nth-child(4)').css({
                    'bottom': '0',
                    'right': '13%',
                    'scale': '0.93'
                });

              
                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '35%',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(4)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
            else if (scrolled >= 170) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '120%',
                    'right': '29%',
                    'scale': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '120%',
                    'right': '28%',
                    'scale': '1'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '120%',
                    'right': '28%',
                    'scale': '1'
                });
                $images.find('img:nth-child(4)').css({
                    'bottom': '0',
                    'right': '28%',
                    'scale': '1'
                });
              
                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(4)').css({
                    'top': '35%',
                    'opacity': '1'
                });
            }
            else {
                $images.find('img:nth-child(1)').css({
                    'bottom': '0',
                    'right': '29%',
                    'scale': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '0',
                    'right': '13%',
                    'scale': '0.93'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '0',
                    'right': '1%',
                    'scale': '0.83'
                });
                $images.find('img:nth-child(4)').css({
                    'bottom': '0',
                    'right': '-6%',
                    'scale': '0.78'
                });
                
            
                $data.find('.data:nth-child(1)').css({
                    'top': '35%',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(4)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
        }
    });
}

function jmgo_mask() {
    if ($('.jmgo-mask').length) {
        $('.jmgo-mask').each(function() {
            let el = $(this);
            let videos = el.find('video'); // handles multiple videos
        
            let scrolled = visiblePercent(el) * 2;
            let mask = Math.min(Math.max(scrolled - 100, 0), 50);
        
            if (scrolled >= 90) {
                let scale = 100 + (mask * 5);
                let opacity = 1 - ((mask * 2) / 100);
        
                el.find('.sticky .mask, .sticky .mask-m').css({
                    'background-size': `${scale}%`,
                    'opacity': `${opacity}`
                });
            }
        
            if (scrolled >= 50) {
                videos.each(function() {
                    this.play();
                });
            } else {
                videos.each(function() {
                    this.pause();
                    this.currentTime = 0;
                });
            }
        
            if (scrolled >= 150) {
                el.find('.aos-init').addClass('aos-animate');
            } else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });
      
        $('.jmgo-mask-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                loop: true,
                autoplay: false,
                stagePadding: 0,
                margin: 15,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 30
                    },
                    1280: {
                        items: 3,
                        stagePadding: 0
                    }
                }
              
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');
        });
      
    }
}